import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CoordinatesInterface } from '../../../dashboard/seller/seller';

@Component({
  selector: 'app-map-dialog',
  templateUrl: './map-dialog.component.html',
  styleUrls: ['./map-dialog.component.scss']
})
export class MapDialogComponent implements OnInit {

  coordinates = {} as CoordinatesInterface;
  coordinatesPlaceholder: any;

  constructor(
    public translate: TranslateService,
    public dialogRef: MatDialogRef<MapDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit() {
    if (this.data.coordinates !== null) {
      this.coordinatesPlaceholder = JSON.parse(this.data.coordinates).split(',');
      this.coordinates.latitude = JSON.parse(this.coordinatesPlaceholder[0]);
      this.coordinates.longitude = JSON.parse(this.coordinatesPlaceholder[1]);
    } else {
      this.coordinates.latitude = 30.044420;
      this.coordinates.longitude = 31.235712;
    }
  }

  placeMarker(event: any) {
    this.coordinates.latitude = event.coords.lat;
    this.coordinates.longitude = event.coords.lng;
    console.log(event.coords.lat);
    console.log(event.coords.lng);
  }

  close() {
    this.dialogRef.close(this.coordinates);
  }

}
